import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { UserSingUpAPI } from "../../../redux/slices/UserSIgnUp";
import { userSignUpSchema } from "../../../schemas/UserSignUpSchema";

const SampleSignUp = () => {
    const dispatch = useDispatch();
    const loading = useSelector((state) => state.UserSignUp.loading);
    const navigate = useNavigate();
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);
    const toggleConfirmPasswordVisibility = () =>
        setConfirmPasswordVisible(!confirmPasswordVisible);

    const formik = useFormik({
        initialValues: {
            name: "",
            email: "",
            password: "",
            confirm_password: "",
            ss_number: "",
            about: "",
            profile: null,
            role: "user",
        },
        validationSchema: userSignUpSchema,
        onSubmit: async (values) => {
            const res = await dispatch(UserSingUpAPI(values));
            if (res?.payload?.status === 200 || res?.payload?.status === true) {
                navigate("/sign-up/email-varification");
            } else {
                console.error("Submission error:", res);
            }
        },
    });

    return (
        <>
            <div className="signup-form pt-5 pb-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-4 col-lg-4 col-md-8">
                            <h1 className="main-form-heading">Sign Up</h1>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-xl-4 col-lg-4 col-md-8">
                            <form onSubmit={formik.handleSubmit}>
                                {/* Name Input */}
                                <div className="mb-3 custom-input-box">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="name"
                                        placeholder="Full Name"
                                        value={formik.values.name}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.name && formik.errors.name && (
                                        <small className="text-danger">{formik.errors.name}</small>
                                    )}
                                </div>

                                {/* Email Input */}
                                <div className="mb-3 custom-input-box">
                                    <input
                                        type="email"
                                        className="form-control"
                                        name="email"
                                        placeholder="Email Address"
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.email && formik.errors.email && (
                                        <small className="text-danger">{formik.errors.email}</small>
                                    )}
                                </div>

                                {/* Password Input */}
                                <div className="mb-3 custom-input-box">
                                    <input
                                        type={passwordVisible ? "text" : "password"}
                                        className="form-control pass-input"
                                        name="password"
                                        placeholder="Password"
                                        value={formik.values.password}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <i
                                        className={`fa-solid ${passwordVisible ? "fa-eye-slash" : "fa-eye"
                                            }`}
                                        onClick={togglePasswordVisibility}
                                        style={{ cursor: "pointer" }}
                                    ></i>
                                    {formik.touched.password && formik.errors.password && (
                                        <small className="text-danger">
                                            {formik.errors.password}
                                        </small>
                                    )}
                                </div>

                                {/* Confirm Password Input */}
                                <div className="mb-3 custom-input-box">
                                    <input
                                        type={confirmPasswordVisible ? "text" : "password"}
                                        className="form-control pass-input"
                                        name="confirm_password"
                                        placeholder="Confirm Password"
                                        value={formik.values.confirm_password}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <i
                                        className={`fa-solid ${confirmPasswordVisible ? "fa-eye-slash" : "fa-eye"
                                            }`}
                                        onClick={toggleConfirmPasswordVisibility}
                                        style={{ cursor: "pointer" }}
                                    ></i>
                                    {formik.touched.confirm_password &&
                                        formik.errors.confirm_password && (
                                            <small className="text-danger">
                                                {formik.errors.confirm_password}
                                            </small>
                                        )}
                                </div>

                                {/* Social Security Number Input */}
                                <div className="mb-3 custom-input-box">
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="ss_number"
                                        placeholder="Social Security Number"
                                        value={formik.values.ss_number}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.ss_number && formik.errors.ss_number && (
                                        <small className="text-danger">
                                            {formik.errors.ss_number}
                                        </small>
                                    )}
                                </div>

                                {/* About Yourself Textarea */}
                                <div className="mb-3 custom-input-box">
                                    <textarea
                                        className="form-control"
                                        name="about"
                                        placeholder="About Yourself"
                                        rows="3"
                                        value={formik.values.about}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    ></textarea>
                                    {formik.touched.about && formik.errors.about && (
                                        <small className="text-danger">{formik.errors.about}</small>
                                    )}
                                </div>

                                {/* Profile Picture Input */}
                                <div className='d-flex justify-content-between align-items-center mb-4'>
                                    <div className="logo-box">
                                        <h3 className="second-text-heading mt-0">Profile Picture</h3>
                                        <label htmlFor="upload-image" className="upload-image">
                                            <span>Upload Image</span>
                                        </label>
                                        <input
                                            type="file"
                                            className="d-none"
                                            id="upload-image"
                                            name="profile"
                                            accept="image/*" // Ensure only image files are accepted
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file && file.type.startsWith('image/')) {
                                                    formik.setFieldValue("profile", file);
                                                } else {
                                                    formik.setFieldValue("profile", null);
                                                    alert('Please upload a valid image file');
                                                }
                                            }}
                                        />
                                        {formik.errors.profile && formik.touched.profile && (
                                            <small className="text-danger">{formik.errors.profile}</small>
                                        )}
                                    </div>

                                    {formik.values.profile && formik.values.profile.type.startsWith('image/') && (
                                        <img
                                            src={URL.createObjectURL(formik.values.profile)}
                                            alt="Uploaded Preview"
                                            className="uploaded-image-preview"
                                        />
                                    )}
                                </div>

                                {/* Submit Button */}
                                <div className="submit-btn-form">
                                    <button
                                        type="submit"
                                        className="btn btn-primary ps-4 pe-4"
                                        disabled={loading}
                                    >
                                        {!loading ? (
                                            "Sign Up"
                                        ) : (
                                            <i
                                                style={{ fontSize: "22px" }}
                                                className="fa-solid fa-spinner fa-spin"
                                            ></i>
                                        )}
                                    </button>
                                </div>
                            </form>

                            <div className="not-a-membder-box">
                                <p className="member-text">
                                    Already a member? <Link to="/signin">Sign In</Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SampleSignUp;
